module.exports = {"data":{"markdownRemark":{"id":"/opt/build/repo/src/pages/corning.md absPath of file >>> MarkdownRemark","html":"<p>Corning</p>","fields":{"slug":"/corning/"},"frontmatter":{"date":"April 09, 2018","title":"Corning","cover":"/img/coffee-gear.png","meta_title":"Corning","meta_description":"Test","username":"corninghustle","tags":["Corning"]}}},"pathContext":{"id":"/opt/build/repo/src/pages/corning.md absPath of file >>> MarkdownRemark"}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/corning.json
// module id = 425
// module chunks = 115072139617743